



















import Vue from "vue";
import { LMarker, LLayerGroup } from "vue2-leaflet";
import TagComponent from "./TagComponent.vue";
import Component from "vue-class-component";
import { LeafletMouseEvent } from "leaflet";
import { maps, features } from "@/store";

const PointComponentProps = Vue.extend({
  props: {
    name: String,
    coords: Array,
    selected: {
      type: Boolean,
      default: false,
    },
    icon: Object,
    textColor: {
      type: String,
      default: "yellow",
    },
  },
});

@Component({
  components: {
    LMarker,
    TagComponent,
    LLayerGroup,
  },
})
export default class PointComponent extends PointComponentProps {
  get platformsTagsEnabledByZoom() {
    return maps.getters.platformsTagsEnabledByZoom;
  }
  get platformTagEnabled() {
    return features.getters.platformTagEnabled;
  }

  get showTag() {
    return (
      this.selected ||
      this.platformTagEnabled ||
      this.platformsTagsEnabledByZoom
    );
  }

  clickHandler(info: LeafletMouseEvent) {
    this.$emit("clicked", info);
  }
}
